import React from 'react';
import Home from './Components/Home';
import About from './Components/About';
import Services from './Components/Services';
import Licinfo from './Components/Licinfo';
import Contact from './Components/Contact';



import {
  BrowserRouter as Router,
  Routes,
  Route,
  
  
  
} from "react-router-dom";
import Navbar from './Components/Navbar';
import Displayform from './Components/Displayform';







const App =() => {
  return (
    <>
    <Navbar/>
    
    
  
    <Router>
      <Routes>
        <Route exact path='/' element={<Home/>}></Route>
        <Route exact path='/Displayform' element={<Displayform/>}></Route>
        
        <Route exact path='/About' element={<About/>}></Route>
        <Route exact path='/Services' element={<Services/>}></Route>
        <Route exact path='/Licinfo' element={<Licinfo/>}></Route>
        <Route exact path='/Contact' element={<Contact/>}></Route>
       
        
      </Routes>
    </Router>
  
    
    </>
  );
};

export default App
